import { downloadPdfBlob, formatCurrency } from "@gymflow/helpers";
import { WalletBalanceHistoryDTO } from "@gymflow/types";
import { useClubSettings } from "apps/portal/src/providers";
import { AuthenticationContext } from "apps/portal/src/providers/authentication/AuthenticationContext";
import { apiV2, queryClient } from "libs/api/src/lib/apiV2";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { Button, DownloadIcon } from "../../../atoms";
import { CreditCardDownIcon } from "../../../atoms/icons/CreditCardDownIcon";
import { CreditCardUpIcon } from "../../../atoms/icons/CreditCardUpIcon";
import { formatDate } from "../../../UserMember/UserMemberPayments/helpers";

const WalletHistoryCard = ({
  amount,
  voucherCode,
  createdAt,
  invoiceNumber,
  type,
}: WalletBalanceHistoryDTO) => {
  const {
    club: { timezone, defaultCurrency },
  } = useClubSettings();
  const { t } = useTranslation();
  const { userId } = useContext(AuthenticationContext);
  const isTopUp =
    type === "CREDIT_REDEEM_VOUCHER" ||
    type === "CREDIT_TOP_UP" ||
    type === "CREDIT_PURCHASE_REFUND";

  return (
    <>
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center">
          {isTopUp ? (
            <div className="bg-success-50 dark:bg-success-800 flex size-8 items-center justify-center rounded-full">
              <CreditCardUpIcon pathClassName="stroke-success-600 dark:stroke-success-200" />
            </div>
          ) : (
            <div className="bg-error-50 dark:bg-error-800  flex size-8 items-center justify-center rounded-full">
              <CreditCardDownIcon pathClassName="stroke-error-600 dark:stroke-error-200" />
            </div>
          )}
          <div className="dark:text-gray-0 ml-2 text-base font-bold text-gray-950">
            {formatCurrency(amount, defaultCurrency)}
          </div>
        </div>
        {invoiceNumber && (
          <Button
            intent="transparent"
            onClick={async () => {
              const data = await queryClient.fetchQuery(
                apiV2.member.member.queries.invoiceFile(userId, invoiceNumber),
              );
              downloadPdfBlob(data, `Gymflow-${invoiceNumber}.pdf`);
            }}
          >
            <DownloadIcon pathClassName="stroke-gray-500" className="size-5" />
            <div className="ml-1 text-sm font-semibold text-gray-500">
              {t("page.userWallets.pdf")}
            </div>
          </Button>
        )}
      </div>
      <div className="flex w-full items-center justify-between">
        <div className="dark:text-gray-0 text-sm font-semibold text-gray-950">
          {voucherCode
            ? t("page.userWallets.voucher", { voucherCode })
            : `#${invoiceNumber}`}
        </div>
        <div className="text-xs font-medium text-gray-500">
          {formatDate(createdAt, timezone)}
        </div>
      </div>
    </>
  );
};

export default WalletHistoryCard;
